import React from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { SystemHealthEnvironmentStatus } from '../../../resources/systems-health/systems-health-model';
import './index.scss';

export interface SystemHealthProps {
  name: string;
  environments: SystemHealthEnvironmentStatus[] | undefined;
}

const SystemEnvironmentHealth: React.FC<SystemHealthProps> = ({ name, environments }) => {
  const getBackgroundColor = (status: string) => {
    switch (status) {
      case 'OK':
        return 'var(--warning-success)';
      case 'DOWN':
        return 'var(--warning-error)';
    }
  };

  return (
    <div className="dashboard-indicator">
      <Row>
        <Col md={8}>{name}</Col>
      </Row>
      {environments ? (
        environments.map((environmentStatus, index) => (
          <Row className="environment-status" key={environmentStatus.environment + index}>
            <Col>{environmentStatus.environment.toUpperCase()}</Col>
            <Col className="indicator">
              <div className="indicator" style={{ backgroundColor: getBackgroundColor(environmentStatus.status) }} />
              {environmentStatus.status}
            </Col>
          </Row>
        ))
      ) : (
        <Spinner as="span" animation="border" size="sm" variant="success" role="status" aria-hidden="true" />
      )}
    </div>
  );
};

export default SystemEnvironmentHealth;
